import { create, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
const factory = create({ theme }).properties();
export const LPWidget = factory(({ properties }) => {
    const { realwidget, name = '', jsondata } = properties();
    let params = {};
    if (jsondata) {
        params = JSON.parse(jsondata);
    }
    return w(realwidget, { key: name, ...params });
});
export default LPWidget;
